import USER_CONFIG from "emun.auth/users/_config";
import TEMPLATE_URL from "emun.auth/users/user-editor-prompt.htm";
import basicController from "servicestack/basic.controller.properties";
import open from "webmodals/open";
//import User from "emun.auth/users/user.model";

const NOOP = () => {};

export default ({
  size = "lg",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  title = "Edit User...",
  subTitle = "",
  hideRole = false,
  user = {},
  labels = {},
  request = {
    permissions: USER_CONFIG.defaultPermissions[user.role] || [],
    ...user,
  },
  onSaved = NOOP,
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      const $ctrl = this;
      basicController($ctrl);
      $ctrl.bus = $ctrl.$session.bus;

      Object.assign($ctrl, { title, subTitle, request, hideRole, labels });
      console.debug(TEMPLATE_URL, request);
      $ctrl.submit = () => {
          if ($ctrl.request.retailerPricing == "Msrp") {
            $ctrl.request.meta.UseMsrp = "true";
            $ctrl.request.meta.UseMsrpMultiplier = "false";
            $ctrl.request.meta.MsrpMultiplier = "";
            $ctrl.request.meta.DealerPricing = "false";
        } else if ($ctrl.request.retailerPricing == "MsrpMultiplier") {
            $ctrl.request.meta.UseMsrp = "false";
            $ctrl.request.meta.UseMsrpMultiplier = "true";
            $ctrl.request.meta.DealerPricing = "false";
        } else if ($ctrl.request.retailerPricing == "DealerPricing") {
            $ctrl.request.meta.UseMsrp = "false";
            $ctrl.request.meta.UseMsrpMultiplier = "false";
            $ctrl.request.meta.MsrpMultiplier = "";
            $ctrl.request.meta.DealerPricing = "true";
        }
          const url =
          ($ctrl.request.id
            ? "UpdateUser"
            : "auth/Register/" + $ctrl.request.role) + ".json";
        $ctrl.bus.send(url, $ctrl.request).then((res) => {
          onSaved({ updated: res.data });
          $ctrl.$close({ updated: res.data });
        });
      };
    },
  }).result;
